<template>
  <div class="">
    <Banner :background="item.image ? item.image.url : ''" :title="$i18n.locale == 'en' ? item.en.title : item.ar.title"
      :subtitle="$i18n.locale == 'en' ? item.en.title : item.ar.title">
    </Banner>

    <section class="links-section pt-100 pb-70" :class="locale == 'ar' ? 'rtl' : 'ltr'">
      <!-- v-if="!pgLoading" in container -->
      <div class="container">
        <div class="team-title-area mb-md-4">
          <div class="row align-items-center">
            <div class="col-lg-12">
              <div class="section-title text-center hidden">
                <span>
                  <i class="flaticon-fame"></i>
                  وصلات المشاركة
                </span>
                <h2 class="font-deco mb-3">جمعية قلب الاطفال الخيرية</h2>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead class="thead-dark" style="text-align: center">
                  <tr>
                    <th scope="col">{{ $t("auth.shared") }}</th>
                    <th class="text-center" scope="col">
                      {{ $t("auth.link") }}
                    </th>
                    <th class="text-center" scope="col">
                      {{ $t("auth.visitors") }}
                    </th>
                    <th class="text-center" scope="col">
                      {{ $t("auth.total_donations") }}
                    </th>
                  </tr>
                </thead>
                <tbody style="text-align: center">
                  <tr v-if="!rows.length">
                    <td colspan="4" class="text-center">
                      <img src="/assets/img/logo/min-logo.png" width="80px" alt="" loading="lazy"
                        class="img-notfound" />
                      <h5 class="no-found-text">{{ $t("app.no_data") }}</h5>
                    </td>
                  </tr>
                  <tr v-for="(row, index) in rows" :key="index">
                    <td style="width: 40%">{{ row.name }}</td>
                    <td class="text-center">
                      <a href="javascript:;" title="Copy to clipboard" v-clipboard:copy="row.link"
                        v-clipboard:success="onCopy" v-clipboard:error="onError">
                        {{ $t("auth.copy_link") }}
                      </a>
                    </td>
                    <td class="text-center">{{ row.visits }}</td>
                    <td class="text-center">
                      {{ row.total_donations }} {{ $t("app.kw") }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <!-- <div v-if="!rows.length" class="text-center">
                                <img src="/assets/img/logo/min-logo.png" 
                                            alt="no found" 
                                            style="margin-top:30px;margin-bottom:30px;width: 100px" 
                                            class="img-notfound" />
                            </div> -->
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script src="vue.min.js"></script>
<script src="dist/vue-clipboard.min.js"></script>
<script>
import { VueTelInput } from "vue-tel-input";
import iziToast from "izitoast";

export default {
  name: "Shares",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    VueTelInput,
  },
  data() {
    return {
      //
      item: {
        image: {
          url: "/assets/img/bg/login-banner.jpg",
        },
        en: {
          title: "My Shares",
        },
        ar: {
          title: "وصلات المشاركة",
        },
      },
      auth: {
        access_token: "",
      },
      locale: "ar",
      pgLoading: true,
      dataLoading: false,

      info: "",
      rows: [],
    };
  },
  mounted() {},
  created() {
    // Auth
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    //
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      // this.axios.defaults.headers.common = {
      //   "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      //   Authorization: `Bearer ` + this.auth.access_token,
      // };
      const options = {
        url: window.baseURL + "/shares",
        headers: {
          "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
          Authorization: `Bearer ` + this.auth.access_token,
        },
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          isUsr: 1,
          status: "active",
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          //this.info = res.data.info;
          this.rows = res.data.rows;
        })
        .catch((err) => {
          // 401 Forbidden
          if (err.response && err.response.status == 401) {
            // this.removeLocalStorage();
            // this.$router.push({ name: "home" });
          }
        })
        .finally(() => {});
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    // Copy to Clipboard
    onCopy: function (e) {
      iziToast.success({
        icon: "ti-check",
        title: "Great job,",
        message: "تم نسخ رابط المشاركة بنجاح",
      });
    },
    onError: function (e) {
      iziToast.error({
        icon: "ti-na",
        title: "Wow-wow,",
        message: "حدث خطأ فيا لخادم, من فضلك حاول مرة آخري",
      });
    },
  },
};
</script>
